module.exports = __webpack_public_path__ + "img/register-title.90d87dd9.png";